import {useQuery} from "@tanstack/react-query";
import {getFavoritePlaces} from "../services/getFavoritePlaces";
import {HealthGuideFavoritePlaceItem} from "../types";
import {QUERY_KEYS} from "infra/libs/react-query/queryKeys";

export function useGetFavoritePlacesQuery() {
  return useQuery<HealthGuideFavoritePlaceItem[]>({
    queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_PLACES],
    queryFn: ({signal}) => getFavoritePlaces({signal}),
  });
}
